import { durationText } from '../../../shared/policies/duration-text';
import type { EtaDeadlineVerdict, TripEta } from '../trips.api';

export interface DeadlineRow {
  label: string;
  /** What to say about the deadline. */
  text: string;
  tone: 'ok' | 'risk' | 'neutral';
}

function describe(verdict: EtaDeadlineVerdict, isTripOut: boolean): Pick<DeadlineRow, 'text' | 'tone'> | null {
  switch (verdict.status) {
    case 'not_applicable':
      return null;
    case 'no_deadline':
      return { text: 'No deadline set', tone: 'neutral' };
    case 'reached':
      return { text: 'Reached', tone: 'ok' };
    case 'no_estimate':
      return { text: isTripOut ? 'No estimate yet' : 'Not on the road yet', tone: 'neutral' };
    case 'on_time':
      return { text: `On time, ${durationText(verdict.slackSeconds)} to spare`, tone: 'ok' };
    case 'at_risk':
      return { text: `At risk, ${durationText(verdict.slackSeconds)} late`, tone: 'risk' };
  }
}

/** The header's deadlines with their slack: only the deadline that applies to this leg, and never a verdict the server did not give. */
export function deadlineRows(eta: TripEta | null, isTripOut: boolean): DeadlineRow[] {
  if (!eta?.deadline) return [];
  const entries: [string, EtaDeadlineVerdict][] = [
    ['Delivery deadline', eta.deadline.delivery],
    ['Empty return deadline', eta.deadline.emptyReturn],
  ];
  return entries.flatMap(([label, verdict]) => {
    const described = describe(verdict, isTripOut);
    return described ? [{ label, ...described }] : [];
  });
}
